













































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'

@Component
export default class ComponentIntegrarRepasses extends Vue {
  loadIntegrarRepasses: boolean = false

  get modalIntegrarRepasses() { return this.getFinanceiroStore.modal.integrarRepasses }
  set modalIntegrarRepasses(value: boolean) { this.getFinanceiroStore.setModal({ name: 'integrarRepasses', value }) }

  get loadingIntegrarRepasses() { return this.loadIntegrarRepasses }
  set loadingIntegrarRepasses(value: boolean) { this.loadIntegrarRepasses = value }

  async integrarRepasses() {
    this.loadingIntegrarRepasses = true
    const response: any = await this.getFinanceiroStore.integrarRepasses()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'A integração dos repasses foi iniciada!', icon: 'done', color: '#2E7D32' })
      this.getFinanceiroStore.getGeracaoRepasseAll()
      this.modalIntegrarRepasses = false
      this.getFinanceiroStore.setModal({ name: 'validacaoEGeracaoRepasse', value: false })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao integrar os repasses.', icon: 'warning', color: '#C62828' })
    }
    this.loadingIntegrarRepasses = false
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }
}
